export const UPLOAD_ATTACHMENTS_TYPES = {
  PROFILE: 'profile-upload',
  TIMEOFF: 'timeoff-upload',
  SHIFT: 'shift-upload',
  ATTENDANCE: 'attendance-upload',
  USERS: 'users-upload'
} as const

export const TAGS_TYPES = ['clients', 'locations', 'resources', 'custom', 'regional'] as const

export const PORTS = {
  XP: 3000,
  NANNY: 3003,
  WA2: 4011,
  CONTACT: 3004,
  RT: 3001
} as const

export const REPORT_TYPES = {
  attendance_report: 'attendance_report',
  contact_acceptation_refusal_report: 'contact_acceptation_refusal_report',
  contact_amount_report: 'contact_amount_report',
  contact_call_Length_report: 'contact_call_Length_report',
  contact_email_amount_report: 'contact_email_amount_report',
  expiring_attributes_report: 'expiring_attributes_report',
  pay_export_generic_report: 'pay_export_generic_report',
  user_contact_report: 'user_contact_report',
  pay_export_apogee_report: 'pay_export_apogee_report',
  pay_export_nethris_report: 'pay_export_nethris_report',
  schedule_analysis_report: 'schedule_analysis_report',
  schedule_export_report: 'schedule_export_report',
  user_attributes_report: 'user_attributes_report',
  vacation_report: 'vacation_report',
  availability_report: 'availability_report',
  daily_summary_report: 'daily_summary_report',
  project_owner_workload_report: 'project_owner_workload_report',
  skyline_report: 'skyline_report',
  time_off_and_Attendance_report: 'time_off_and_Attendance_report',
  unscheduled_users_report: 'unscheduled_users_report',
  project_user_status_report: 'project_user_status_report',
  questionnaire_responses: 'questionnaire_responses',
  attendance_raw_report: 'attendance_raw_report',
  vacation_raw_report: 'vacation_raw_report'
} as const

export const REPORTS_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  READY: 'ready',
  FAILED: 'failed'
} as const
